import React from 'react';

const Sun = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 481.882 481.882">
        <circle cx="240.941" cy="240.941" r="138.541" fill="#fcd462" />
        <g fill="#f6c358">
            <path d="M306.598,118.664c6.024,19.275,10.24,39.755,10.842,60.838 c3.614,83.727-53.007,157.816-126.494,190.344c15.661,6.024,32.527,9.638,49.995,9.638c76.499,0,138.541-62.042,138.541-138.541 C379.482,187.934,349.967,142.155,306.598,118.664z"
            />
            <path d="M240.941,0c-11.445,0-20.48,9.035-20.48,20.48v33.732c0,11.445,9.035,20.48,20.48,20.48 s20.48-9.035,20.48-20.48V20.48C261.421,9.035,252.386,0,240.941,0z"
            />
            <path d="M240.941,407.191c-11.445,0-20.48,9.035-20.48,20.48v33.732c0,11.445,9.035,20.48,20.48,20.48 s20.48-9.035,20.48-20.48v-33.732C261.421,416.226,252.386,407.191,240.941,407.191z"
            />
            <path d="M481.882,240.941c0-11.445-9.035-20.48-20.48-20.48h-33.732c-11.445,0-20.48,9.035-20.48,20.48 s9.035,20.48,20.48,20.48h33.732C472.847,261.421,481.882,252.386,481.882,240.941z"
            />
            <path d="M74.692,240.941c0-11.445-9.035-20.48-20.48-20.48H20.48c-11.445,0-20.48,9.035-20.48,20.48 s9.035,20.48,20.48,20.48h33.732C65.656,261.421,74.692,252.386,74.692,240.941z"
            />
            <path d="M411.407,70.475c-7.831-7.831-21.082-7.831-28.913,0L358.4,94.569 c-7.831,7.831-7.831,21.082,0,28.913c7.831,7.831,21.082,7.831,28.913,0l24.094-24.094 C419.238,91.558,419.238,78.306,411.407,70.475z"
            />
            <path d="M123.482,358.4c-7.831-7.831-21.082-7.831-28.913,0l-24.094,24.094 c-7.831,7.831-7.831,21.082,0,28.913c7.831,7.831,21.082,7.831,28.913,0l24.094-24.094 C131.313,379.482,131.313,366.833,123.482,358.4z"
            />
            <path d="M411.407,411.407c7.831-7.831,7.831-21.082,0-28.913L387.313,358.4 c-7.831-7.831-21.082-7.831-28.913,0c-7.831,7.831-7.831,21.082,0,28.913l24.094,24.094 C390.325,419.238,403.576,419.238,411.407,411.407z"
            />
            <path d="M123.482,123.482c7.831-7.831,7.831-21.082,0-28.913L99.388,70.475 c-7.831-7.831-21.082-7.831-28.913,0s-7.831,21.082,0,28.913l24.094,24.094C102.4,131.313,115.049,131.313,123.482,123.482z"
            />
        </g>
    </svg>
);

export default Sun;